import { put, call } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as actions from '../actions/admin';
import {
  get,
  post,
  del,
  axiosPut
} from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getUsersList({ payload }) {
  try {
    const response = yield call(get, '/admin/users');
    yield put(actions.getUsersListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getUsersListFail());
  }
}

export function* getRolesOnUser({ payload }) {
  try {
    const response = yield call(get, `/admin/roles/${payload.userId}`);
    yield put(actions.getRolesOnUserSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getRolesOnUserFail());
  }
}

export function* getUsersOnRole({ payload }) {
  try {
    const response = yield call(get, `/admin/users/role/${payload.roleId}`);
    yield put(actions.getUsersOnRoleSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getUsersOnRoleFail());
  }
}

export function* createRole({ payload }) {
  try {
    const response = yield call(post, '/admin/roles', payload);
    yield call(
      notify,
      {
        message: 'Роль успешно добавлена',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const responseRoleList = yield call(get, '/admin/roles');
    yield put(
      actions.getRolesListSuccess(
        responseRoleList.sort((a, b) => {
          if (a.roleName < b.roleName) {
            return -1;
          }
          if (a.roleName > b.roleName) {
            return 1;
          }
          return 0;
        })
      )
    );
    yield put(
      actions.createRoleSuccess(response)
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.createRoleFail());
  }
}

export function* getRolesList({ payload }) {
  try {
    const response = yield call(get, '/admin/roles');
    yield put(
      actions.getRolesListSuccess(
        response.sort((a, b) => {
          if (a.roleName < b.roleName) {
            return -1;
          }
          if (a.roleName > b.roleName) {
            return 1;
          }
          return 0;
        })
      )
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
  }
  yield put(actions.getRolesListFail());
}

export function* addRoleOnUser({ payload }) {
  try {
    yield call(
      post,
      `/admin/users/roles?roleId=${payload.roleId}&userId=${payload.userId}`
    );
    yield put(actions.addRoleOnUserSuccess());
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(get, `/admin/roles/${payload.userId}`);
    yield put(actions.getRolesOnUserSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addRoleOnUserFail());
  }
}

export function* deleteRoleOnUser({ payload }) {
  try {
    yield call(
      del,
      `/admin/users/roles?roleId=${payload.roleId}&userId=${payload.userId}`
    );
    yield put(actions.deleteRoleOnUserSuccess());
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(get, `/admin/roles/${payload.userId}`);
    yield put(actions.getRolesOnUserSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.deleteRoleOnUserFail());
  }
}

export function* createOrUpdateUser({ payload }) {
  try {
    if (!payload.userId) {
      const response = yield call(
        post,
        '/admin/users',
        {
          deletedFlag: payload.deletedFlag && payload.deletedFlag !== 'N' ? 'Y' : 'N',
          isVendorUser: payload.isVendorUser && payload.isVendorUser !== 'N' ? 'Y' : 'N',
          emailAddress: payload.emailAddress,
          name: payload.name,
          notes: payload.notes,
          phoneNumber: payload.phoneNumber ? `7${payload.phoneNumber}` : payload.phoneNumber,
          requestId: payload.requestId,
          userName: payload.userName
        }
      );
      yield call(
        notify,
        {
          message: 'Пользователь успешно добавлен',
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      const responseUserList = yield call(get, '/admin/users');
      yield put(actions.getUsersListSuccess(responseUserList));
      yield put(actions.createOrUpdateUserSuccess(response));
    } else {
      yield call(
        axiosPut,
        `/admin/users/${payload.userId}`,
        {
          deletedFlag: payload.deletedFlag && payload.deletedFlag !== 'N' ? 'Y' : 'N',
          isVendorUser: payload.isVendorUser && payload.isVendorUser !== 'N' ? 'Y' : 'N',
          emailAddress: payload.emailAddress,
          name: payload.name,
          notes: payload.notes,
          phoneNumber: payload.phoneNumber ? `${payload.phoneNumber}` : payload.phoneNumber,
          requestId: payload.requestId,
          userName: payload.userName
        }
      );
      yield call(
        notify,
        {
          message: 'Пользователь успешно обновлен',
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      const responseUserList = yield call(get, '/admin/users');
      yield put(actions.getUsersListSuccess(responseUserList));
      yield put(actions.createOrUpdateUserSuccess());
    }
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.createOrUpdateUserFail());
  }
}

export function* updateRole({ payload }) {
  try {
    yield call(
      axiosPut,
      `/admin/roles/${payload.roleId}`,
      {
        roleName: payload.roleName,
        description: payload.description
      }
    );
    yield call(
      notify,
      {
        message: 'Роль успешно обновлена',
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const responseRoleList = yield call(get, '/admin/roles');
    yield put(
      actions.getRolesListSuccess(
        responseRoleList.sort((a, b) => {
          if (a.roleName < b.roleName) {
            return -1;
          }
          if (a.roleName > b.roleName) {
            return 1;
          }
          return 0;
        })
      )
    );
    yield put(actions.updateRoleSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.updateRoleFail());
  }
}

export function* plantVisit({ payload }) {
  try {
    yield call(
      post,
      `/admin/users/plant-visit/${payload.plantId}`
    );
  } catch (error) {
    // console.error('ERROR Plant-Visit', error);
  }
}

export function* getPiecesList({ payload }) {
  try {
    const response = yield call(
      post,
      '/admin/pieces/',
      payload
    );
    yield put(actions.getPiecesListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getPiecesListFail());
  }
}

export function* changePiecesPlant({ payload }) {
  try {
    const response = yield call(
      post,
      '/admin/pieces/plant/change',
      payload
    );
    yield put(actions.changePiecesPlantSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.changePiecesPlantFail());
  }
}

export function* changePiecesStatus({ payload }) {
  try {
    const response = yield call(
      post,
      '/admin/pieces/status/change',
      payload
    );
    yield put(actions.changePiecesStatusSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.changePiecesStatusFail());
  }
}

export function* getStatusesList({ payload }) {
  try {
    const response = yield call(
      get,
      '/list/statuses/'
    );
    yield put(actions.getStatusesListSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getStatusesListFail());
  }
}

export function* getVisitsUser({ payload }) {
  try {
    const response = yield call(
      post,
      `/admin/users/visits/${payload.userId}`,
      {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        plantShortDescr: payload.filter
      }
    );
    yield put(actions.getVisitsUserSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getVisitsUserFail());
  }
}

export function* getPermissionsOnRole({ payload }) {
  try {
    const response = yield call(get, `/admin/permission/${payload.roleId}`);
    yield put(actions.getPermissionsOnRoleSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getPermissionsOnRoleFail());
  }
}

export function* getPermissions({ payload }) {
  try {
    const response = yield call(get, 'admin/permission');
    yield put(actions.getPermissionsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* getPermissionValues({ payload }) {
  try {
    const response = yield call(get, `admin/permission/value/${payload.permId}`);
    yield put(actions.getPermissionValuesSuccess(
      response.sort((a, b) => {
        if (a.valueDescription < b.valueDescription) {
          return -1;
        }
        if (a.valueDescription > b.valueDescription) {
          return 1;
        }
        return 0;
      })
    ));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getPermissionValuesFail());
  }
}

export function* addPermissionOnRole({ payload }) {
  try {
    yield call(
      post,
      `/admin/roles/permission?roleId=${payload.roleId}&spvId=${payload.spvId}`
    );
    yield put(actions.addPermissionOnRoleSuccess());
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(get, `/admin/permission/${payload.roleId}`);
    yield put(actions.getPermissionsOnRoleSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addPermissionOnRoleFail());
  }
}

export function* deletePermissionOnRole({ payload }) {
  try {
    yield call(
      del,
      `/admin/roles/permission/${payload.srpId}`
    );
    yield put(actions.deletePermissionOnRoleSuccess());
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(get, `/admin/permission/${payload.roleId}`);
    yield put(actions.getPermissionsOnRoleSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.deletePermissionOnRoleFail());
  }
}
